export const BIRTH = 'birth'
export const FULL_NAME = 'fullName'
export const NOTES = 'notes'
export const PARENTAL_RESPONSIBILITY_OF = 'parentalResponsibilityOf'
